const headers = document.querySelectorAll('.awards-list-item__header');

headers.forEach((header, index) => {
    const body = header.nextElementSibling;

    if (!body?.classList.contains('awards-list-item__body')) return;

    const id = `awards-body-${index}`;
    body.id = id;
    header.setAttribute('aria-expanded', 'false');
    header.setAttribute('aria-controls', id);
    header.setAttribute('tabindex', '0');

    const toggle = () => {
        const isOpen = header.getAttribute('aria-expanded') === 'true';

        // Ferme tous les autres
        headers.forEach((h) => {
            h.setAttribute('aria-expanded', 'false');
            h.closest('.awards-list-item').classList.remove('open');
        });

        // Ouvre celui-ci si il était fermé
        if (!isOpen) {
            header.setAttribute('aria-expanded', 'true');
            header.closest('.awards-list-item').classList.add('open');
        }
    };

    header.addEventListener('click', toggle);
    header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
        }
    });

    // Ouvre le premier par défaut
    if (index === 0) {
        header.setAttribute('aria-expanded', 'true');
        header.closest('.awards-list-item').classList.add('open');
    }
});
